export default function currencyType(currencyType) {
    switch (currencyType) {
        case 'LTC':
            return (
                'LTC_ADDRESS'
            )
        case 'XRP':
            return (
                'XRP_ADDRESS'
            )
        case 'ETH':
        case 'ETH_USDT':
        case 'ETH_UAX':
        case 'ETH_TRUE_USD':
        case 'ETH_USDC':
        case 'ETH_DAIM':
        case 'ETH_DAI':
        case 'ETH_OKB':
        case 'ETH_MKR':
        case 'ETH_KNC':
        case 'ETH_BNT':
        case 'ETH_PAX':
        case 'ETH_UNI':
        case 'ETH_LINK':
        case 'ETH_SHIB':
        case 'ETC':
        case 'BNB_SMART':
        case 'BNB_SMART_ADA':
            return (
                'ETH_ADDRESS'
            )
        case 'BTC':
        case 'USDT':
        case 'BSV':
            return (
                'BTC_ADDRESS'
            )
        case 'BTH':
            return (
                'BTH_ADDRESS'
            )
        case 'TRX':
        case 'TRX_USDT':
        case 'TRX_BTT':
            return (
                'TRX_ADDRESS'
            )
        case 'DOGE':
            return (
                'DOGE_ADDRESS'
            )
        case 'XMR':
            return (
                'XMR_ADDRESS'
            )
        case 'XLM':
        case 'BCH':
        case 'BNB':
        case 'TON':
            return 'NOT_VERIFY'
        default:
            return null
    }
}